module.exports = __webpack_public_path__ + "img/home-bottom.d130634d.png";